import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecked = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2004_944)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M49.8917 8.30181L15.2012 48.4222L0.160645 32.0711L3.84057 28.6862L15.0858 40.9111L46.1095 5.03149L49.8917 8.30181Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2004_944",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 50,
			height: 50,
			fill: "white",
			transform: "translate(0.000488281 0.666656)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgChecked);
export default ForwardRef;
